import { useSearchParams } from '@remix-run/react';
import { useRef, useState } from 'react';
import { useIsVisible } from '~/hooks/useIsVisible';
import { usePreviewCtx } from '~/utils/Context';
import { BlinkFrame } from './BlinkFrame';
import { Scale } from './Scale';

type Props = {
    scale: number;
};

function ScaledPreview({ scale }: Props) {
    let [searchParams] = useSearchParams();
    const adId = searchParams.get('finnkode') || '';
    const { previewAdId } = usePreviewCtx();

    const [showAdIdFromUrl, setShowAdIdFromUrl] = useState(true);
    const [showRecommendation, setShowRecommendation] = useState(true);
    const [showRandomAdId, setShowRandomAdId] = useState(true);

    if (showAdIdFromUrl) {
        return (
            <BlinkFrame
                style={{
                    aspectRatio: '5 / 4',
                    height: 300,
                    width: 375,
                    minWidth: 'auto',
                    transformOrigin: 'top left',
                    transform: `scale(${scale})`,
                }}
                position="news_swipe"
                autoSwipe={true}
                className="news-swipe"
                adId={adId}
                onLoad={() => {}}
                onError={() => {
                    setShowAdIdFromUrl(false);
                }}
            />
        );
    } else if (showRecommendation) {
        return (
            <BlinkFrame
                style={{
                    aspectRatio: '5 / 4',
                    height: 300,
                    width: 375,
                    minWidth: 'auto',
                    transformOrigin: 'top left',
                    transform: `scale(${scale})`,
                }}
                position="news_swipe"
                autoSwipe={true}
                className="news-swipe"
                onLoad={() => {}}
                onError={() => {
                    setShowRecommendation(false);
                }}
            />
        );
    } else if (showRandomAdId) {
        return (
            <BlinkFrame
                style={{
                    aspectRatio: '5 / 4',
                    height: 300,
                    width: 375,
                    minWidth: 'auto',
                    transformOrigin: 'top left',
                    transform: `scale(${scale})`,
                }}
                position="news_swipe"
                autoSwipe={true}
                className="news-swipe"
                adId={previewAdId?.toString()}
                onLoad={() => {}}
                onError={() => {
                    setShowRandomAdId(false);
                }}
            />
        );
    } else {
        return (
            <img
                loading="lazy"
                src="/blink/images/mobile-swipe.webp"
                alt="swipe"
                style={{
                    aspectRatio: '5 / 4',
                    height: 300,
                    width: 375,
                    minWidth: 'auto',
                    transformOrigin: 'top left',
                    transform: `scale(${scale})`,
                    maxWidth: 'none',
                }}
            />
        );
    }
}

export function SwipePreview() {
    const ref = useRef<HTMLDivElement>(null);
    const visible = useIsVisible(ref, 0.1);
    return (
        <Scale
            containerRef={ref}
            className="w-full overflow-hidden"
            style={{
                aspectRatio: '5 / 4',
            }}
            height={300}
            width={375}>
            {(scale) => {
                if (visible) {
                    return <ScaledPreview scale={scale} />;
                }
                return null;
            }}
        </Scale>
    );
}
